exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".accordion{background:#fff;box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 3px rgba(0,0,0,.24);margin-bottom:20px;padding:18px;background-color:#fff;margin-bottom:10px;padding:0;transition:all .2s ease}.accordion header{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:1.8rem;margin-bottom:10px}.accordion .accordion-body{-ms-flex-positive:1;flex-grow:1;padding:0 20px 20px}.is-open .accordion-header{background-color:#fff}.is-open .accordion-icon{transform:rotate(90deg);transform-origin:40% 60%;transition:all .2s ease}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/shared/components/accordion/index.scss
// module id = 5227
// module chunks = 0